import { useState } from 'react'

import { WidgetContentContainer } from '../../Widget'
import { Component, ComponentProps } from '../Component'
import { controls, node } from '../Controls'

import { WidgetProviderProps } from './WidgetProviderProps'

export function WidgetContentContainerUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(node('children', 'Possible text inside widget'))
  )

  return (
    <WidgetProviderProps>
      <Component
        {...props.getValues()}
        Component={WidgetContentContainer}
        name='WidgetContentContainer'
      />
      <ComponentProps
        name='WidgetContentContainer'
        value={props}
        onChange={setProps}
      />
    </WidgetProviderProps>
  )
}
